import axios from '../../Axios/Axios'
import { currentRequestTimeStamp, Activity } from '../../Constants'
// import { isMobile, currentRequestTimeStamp, Activity } from '../../Constants';
import { Urls } from '../../Urls';


// Not used - check for use 
// export const save = (payload) => {
//     Activity([{ "screen": "Company Profile", "module": "Company Profile", "user_activity": `Save Button clicked`, "timestamp": currentRequestTimeStamp() }])
//     var id = ''

//     getCompanyID()
//         .then(res => {
//             id = res.data.domain_data.company_id

//             axios.post(Urls.companyProfile, { "data": [{ company_id: id, payload }] })
//                 .then(res => {
//                     // console.log(res.data)
//                     // toast.success("Data submitted successfully")
//                     // setedit(false)
//                     // setactive(1)
//                     // edit = false
//                 })
//                 .catch(err => {
//                     console.log(err)
//                     // edit = true
//                 })

//         })
//         .catch(err => {
//             console.log(err)
//         })

// }
export const saveapi = (id, payload, TrackMixPanel = () => { }, email, user_name) => {
    Activity([{
        screen: "Company Profile",
        module: "Company Profile",
        user_activity: `Save Button clicked`,
        timestamp: currentRequestTimeStamp()
        , "userEmail": email, "userName": user_name,
        companyname: email ? email.split("@")[1].split(".")[0] : ""
    }])

    if (TrackMixPanel && TrackMixPanel !== "") {
        TrackMixPanel({
            ModuleName: 'masters',
            ScreenName: 'location master',
            Data: 'none',
            Definition: 'user has clicked company profile save button',
        })
    }
    // var a = { "data": [payload] }
    // console.log(a)

    return axios.post(Urls.companyProfile, { "data": [payload] })
}
export const saveMastersApi = (id, master_type, payload, selectedOrg, TrackMixPanel = () => { }, email, userName) => {
    Activity([{
        screen: "Company Master",
        module: "Company Master",
        user_activity: `Save Button clicked`,
        timestamp: currentRequestTimeStamp(), "userEmail": email, "userName": userName
        , companyname: email ? email.split("@")[1].split(".")[0] : ""
    }])

    if (TrackMixPanel && TrackMixPanel !== "") {
        TrackMixPanel({
            ModuleName: 'masters',
            ScreenName: 'location master',
            Data: 'none',
            Definition: 'user has clicked company master save button',
        })
    }

    const baseUrl = `${Urls.companyMaster}?master_type=${master_type}&company_id=${id}`
    if (selectedOrg && selectedOrg !== "company") {
        return axios.post(`${baseUrl}&organization_id=${selectedOrg}`, { "data": payload })
    } else {
        return axios.post(baseUrl, { "data": payload })
    }
}
export const DeleteMastersApi = (id, master_type, payload, selectedOrg, TrackMixPanel = () => { }, email, userName) => {
    Activity([{
        screen: "Company Master",
        module: "Company Master",
        user_activity: `Delete Button clicked`,
        timestamp: currentRequestTimeStamp(), "userEmail": email, "userName": userName
        , companyname: email ? email.split("@")[1].split(".")[0] : ""
    }])

    if (TrackMixPanel && TrackMixPanel !== "") {
        TrackMixPanel({
            ModuleName: 'masters',
            ScreenName: 'location master',
            Data: 'none',
            Definition: 'user has clicked company master delete button',
        })
    }

    const baseUrl = `${Urls.companyMaster}?company_id=${id}&master_type=${master_type}&status=deleted`
    if (selectedOrg && selectedOrg !== "company") {
        return axios.post(`${baseUrl}&organization_id=${selectedOrg}`, { "data": payload })
    } else {
        return axios.post(baseUrl, { "data": payload })
    }
}

export const getCompanyID = (email) => {
    return axios.get(`${Urls.companyProfile}?email=${email}`)
}

export const getProfileDetails = (id, projection, selectedOrg) => {
    const baseUrl = `${Urls.companyProfile}?company_id=${id}`
    if (selectedOrg && selectedOrg !== "company") {
        return axios.get(`${baseUrl}&organization_id=${selectedOrg}&projections_enable=${projection}`)
    } else {
        return axios.get(`${baseUrl}&projections_enable=${projection}`)
    }
}

export const getProfileDetailsDisabled = (id, projection) => {
    return axios.get(`${Urls.companyProfile}?company_id=${id}&projections_disable=${projection}`)
}

export const getCompanyMaster = (id, master_type, selectedOrg) => {
    const baseUrl = `${Urls.companyMaster}?master_type=${master_type}&company_id=${id}`
    if (selectedOrg && selectedOrg !== "company") {
        return axios.get(`${baseUrl}&organization_id=${selectedOrg}`)
    } else {
        return axios.get(baseUrl)
    }
}

export const getCompanyMasterPagination = (id, master_type, skip, limit, selectedOrg) => {
    const calculatedSkip = skip
    const baseParams = `master_type=${master_type}&company_id=${id}&skip=${calculatedSkip}&limit=${limit}${master_type === "route" ? "&action=get_route_master" : ""}`
    if (selectedOrg && selectedOrg !== "company") {
        return axios.get(`${Urls.companyMaster}?${baseParams}&organization_id=${selectedOrg}`)
    } else {
        return axios.get(`${Urls.companyMaster}?${baseParams}`)
    }
}

export const canEdit = (res, email) => {
    if (res.data.message || res.data[0].contact_information === undefined || res.data[0].contact_information.length === 0) {
        return false
    }
    if (res.data && res.data.length > 0) {
        if (res.data[0].contact_information && res.data[0].contact_information.length > 0) {
            const contacts = res.data[0].contact_information
            for (let i = 0; i < contacts.length; i++) {
                if (contacts[i].email === email) {
                    if (contacts[i].super_admin && contacts[i].super_admin === true) {
                        return false
                    }
                }
            }
            return true
        } else {
            return true
        }
    } else {
        return true
    }
}

export const cancel = (e, TrackMixPanel = () => { }, mail, userName) => {
    if (window.confirm("All unsaved changes will be lost! Are you sure to proceed?")) {
        window.location.reload()
        Activity([{
            screen: "Company Profile",
            module: "Company Profile",
            user_activity: `Cancel button clicked`,
            timestamp: currentRequestTimeStamp(), "userEmail": mail, "userName": userName
            , companyname: mail ? mail.split("@")[1].split(".")[0] : ""
        }])

        if (TrackMixPanel) {
            TrackMixPanel({
                ModuleName: 'masters',
                ScreenName: 'location profile',
                Data: 'none',
                Definition: 'user has clicked cancel button on company profile',
            })
        }
    }
}

export const MastersChangeLog = (action, screen_name, email_id, user_id, company_id, activity, remark, team, customPayload = null) => {
    const payload = {
        action: action,
        screen: screen_name,
        user_email: email_id,
        user_id,
        company_id,
        timestamp: currentRequestTimeStamp(),
        team,
    }

    if (activity || remark) {
        payload.change_activity = activity
        payload.remarks = remark
    }

    const finalPayload = customPayload || payload

    axios.post(`${Urls.planning}/change_log`, finalPayload)
        .catch((error) => {
            console.log(error)
        })
}

export const findObjectDifferences = (prevObj, updatedData) => {
    const differences = {}
    for (const key in updatedData) {
        if (prevObj.hasOwnProperty(key)) {
            if (prevObj[key] !== updatedData[key]) {
                differences[key] = updatedData[key]
            }
        } else {
            differences[key] = updatedData[key]
        }
    }
    return differences
}

export const getCommonKeys = (prevData, diffData) => {
    const result = {}
    for (let key in prevData) {
        if (diffData.hasOwnProperty(key)) {
            result[key] = prevData[key]
        }
    }
    return result
}

/**
 * Compares two objects and returns an object containing the differences.
 * 
 * @param {Object} original - Original object to compare.
 * @param {Object} modified - Modified object to compare against the original.
 * @param {string} id - Identifier to determine which value to keep in the result.
 * @returns {Object} Object containing the differences between the original and modified objects.
 */
export const findChangedValues = (original, modified, id) => {
    /**
 * Recursively compares two objects and returns their differences.
 * 
 * @param {Object} obj1 - first object to compare.
 * @param {Object} obj2 - second object to compare.
 * @returns {Object} An object containing the differences between obj1 and obj2.
 */
    const compareObjects = (obj1, obj2) => {
        const result = {}
        for (let key in obj1) {
            if (obj2.hasOwnProperty(key)) {
                if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                    if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
                        result[key] = id === "changed_value" ? obj2[key] : obj1[key];
                    }
                } else if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                    const nestedComparison = compareObjects(obj1[key], obj2[key])
                    if (Object.keys(nestedComparison).length > 0) {
                        result[key] = nestedComparison
                    }
                } else if (obj1[key] !== obj2[key]) {
                    result[key] = id === 'changed_value' ? obj2[key] : obj1[key]
                }
            }
        }
        return result
    }
    return compareObjects(original, modified)
}
